import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const DailyUsers = () => {
    const { analytics, isLoading, defaultData } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='24h Users'
            percentageDifference={
                analytics ? analytics.dailyUsers.dailyDiffPercentage.toString() : '0'
            }
            amount={formatUSD(analytics?.dailyUsers.currentValue.toString() || '0', {
                maxDecimals: 0,
                currency: '',
            })}
            data={analytics?.dailyUsers.historicalData ?? defaultData}
            isLoading={isLoading}
            showPercentage
        />
    );
};

export default DailyUsers;
